import React from "react";
import { inject, observer } from "mobx-react";
import "./stylesheets/checkErrorInfo.scss";

@inject("teamStore", "languageStore")
@observer
export default class CheckErrorInfo extends React.Component {
  render() {
    if (!(this.props.checkErrorInfo && this.props.checkErrorInfo.length > 0)) {
      return null;
    }
    const lang = this.props.languageStore.lang;
    return (
      <div className="check-error-info">
        {this.props.checkErrorInfo.map((item, idx) => {
          const info = item.info[lang];
          const members = item.members && item.members[lang];
          if (item.info.zh.includes("人数")) {
            return (
              <div className="check-error-info__box" key={idx.toString()}>
                {members && members.length > 0 ? (
                  <div className="check-error-info__box--info">
                    {`${members.join("、")}`}
                  </div>
                ) : null}
                <div>{info}</div>
              </div>
            );
          }
          return (
            <div className="check-error-info__box" key={idx.toString()}>
              <div>{info}</div>
              {members && members.length > 0 ? (
                <div className="check-error-info__box--info">
                  {`${members.join("、")}`}
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/checkErrorInfo.js